import {
	IconColorPaletteOutline18 as ColorIcon,
	IconTableRowsOutline18 as ColorTableIcon,
} from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../../types"
import { iconClassName } from "../../constants"

export const colorSwatchesCommand: SlashCommandDefinition = {
	key: "color-swatches",
	title: "Color swatches",
	icon: <ColorIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor
			.chain()
			.focus()
			.deleteRange(range)
			.insertColorSwatches("compact")
			.run()
	},
	group: "blocks",
	aliases: ["color", "colour", "swatch", "swatches", "palette"],
}

export const colorTableCommand: SlashCommandDefinition = {
	key: "color-table",
	title: "Color table",
	icon: <ColorTableIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertColorSwatches("table").run()
	},
	group: "blocks",
	aliases: ["color table", "colour table", "palette table", "design tokens"],
}
